import React from 'react'

const SupplierIcon = () => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="supplierIcon">
      <path
        d="M21 17.5H18.6666V19.8333H21M21 12.8333H18.6666V15.1667H21M23.3333 22.1667H14V19.8333H16.3333V17.5H14V15.1667H16.3333V12.8333H14V10.5H23.3333M11.6666 8.16667H9.33331V5.83333H11.6666M11.6666 12.8333H9.33331V10.5H11.6666M11.6666 17.5H9.33331V15.1667H11.6666M11.6666 22.1667H9.33331V19.8333H11.6666M6.99998 8.16667H4.66665V5.83333H6.99998M6.99998 12.8333H4.66665V10.5H6.99998M6.99998 17.5H4.66665V15.1667H6.99998M6.99998 22.1667H4.66665V19.8333H6.99998M14 8.16667V3.5H2.33331V24.5H25.6666V8.16667H14Z"
        fill="#EF8658"
      />
    </g>
  </svg>
)

export default SupplierIcon
